"use client";
import React from "react";
import {
  Stack,
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Center,
  HStack,
  Icon,
  Text,
} from "@chakra-ui/react";
import { FaMinus, FaPlus } from "@onemind-services-llc/react-icons-ng/fa";

type AccordionListProps = {
  items: {
    content: React.ReactNode;
    title: string;
  }[];
};

const AccordionList = (props: AccordionListProps) => {
  const { items } = props;
  return (
    <Stack data-cy="section-faq">
      {items.map((item, index) => {
        const { content, title } = item;
        return (
          <Accordion allowToggle key={index}>
            <AccordionItem
              borderColor={"#eee"}
              borderRadius={"4px"}
              borderWidth={"1px"}
              p={"7px 7px 7px 0"}
            >
              {({ isExpanded }) => (
                <>
                  <AccordionButton _hover={{}}>
                    <HStack>
                      {isExpanded ? (
                        <Center bg={"#6ec1e4"} borderRadius={"50%"} h={"25px"} w={"25px"}>
                          <Icon
                            color={"whiteAlpha.900"}
                            as={FaMinus}
                            fontSize="20px"
                            minW={"25px"}
                            maxW={"25px"}
                          />
                        </Center>
                      ) : (
                        <Center bg={"#6ec1e4"} w={"25px"} h={"25px"} borderRadius={"50%"}>
                          <Icon
                            color={"whiteAlpha.900"}
                            as={FaPlus}
                            fontSize="18px"
                            minW={"25px"}
                            maxW={"25px"}
                          />
                        </Center>
                      )}
                      <Text>{title}</Text>
                    </HStack>
                  </AccordionButton>
                  <AccordionPanel pb={4}>
                    {Array.isArray(content)
                      ? content.map((ans, index) => <Text key={index}>{ans}</Text>)
                      : content}
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
          </Accordion>
        );
      })}
    </Stack>
  );
};

export default AccordionList;
